<div id="our-logo" style="width:230px; height:63px" [routerLink]="link" style="cursor: pointer" matTooltip="Go to home page">
  <img [src]="customLogo" style="width:163px; height: 53px; margin-top: 5px; margin-left: 33px;" alt=""/>
</div>
